import { Injectable, OnDestroy } from '@angular/core';

import { ApiService } from '../api/services/api.service';
import { LoggerService } from '../core/services/logger/logger.service';
import { FeatureSwitch } from '../core/services/interfaces';
import { FeatureSwitchService } from '../core/services/feature-switch/feature-switch.service';
import { ArcMetricSubmitter } from './arc-metric-submitter';
import { IUserMetricDimensions } from './interfaces';
import { SessionHandlerService } from '../shared/services/session-handler.service';

@Injectable({
  providedIn: 'root'
})
export class MetricsSubmitterService implements OnDestroy {
  private currentMetricSubmitter?: ArcMetricSubmitter;
  constructor(
    private apiService: ApiService,
    private loggerService: LoggerService,
    private featureSwitchService: FeatureSwitchService,
    private sessionHandlerService: SessionHandlerService
  ) {}

  public createArcMetricSubmitter(extensionId: string) {
    this.currentMetricSubmitter?.destroy();
    this.currentMetricSubmitter = new ArcMetricSubmitter(extensionId, this.apiService, this.loggerService);
  }

  public ngOnDestroy() {
    this.currentMetricSubmitter?.destroy();
  }

  public trackMetric(name: string, value: number, dimensions: IUserMetricDimensions): void {
    if (!this.featureSwitchService.featureSwitch(FeatureSwitch.TrackMetrics)) {
      return;
    }
    if (!this.currentMetricSubmitter) {
      return;
    }
    this.currentMetricSubmitter?.trackMetric(name, value, { ...this.sessionDimensions, ...dimensions });
  }

  private get sessionDimensions() {
    return {
      sessionId: this.sessionHandlerService.sessionId,
      sessionFromCookie: this.sessionHandlerService.sessionFromCookie ? 'true' : 'false'
    };
  }
}
